import React from 'react';
import { Navigate, Route, Routes, To, useNavigate } from 'react-router-dom';
import { AdminPrivateRoutes as AdminPrivateRoutesDirectives, PublicRoutes } from './routeConstans';
import Company from 'pages/Admin/companies';
import Employees from 'pages/Admin/companies/employees';
import Classififcation from 'pages/Admin/companies/classification';
import PrivateLayout from 'pages/Admin';
import Admins from 'pages/Admin/admins';
import { useDispatch } from 'react-redux';
import { logout } from 'store/actions/UserAction';
// import moment from 'moment';
import { useIdleTimer } from 'react-idle-timer';
import { toast } from 'react-toastify';
import { alertOptions } from 'utils/Config';
import Questions from 'pages/Admin/surveyquestions';
import Categories from 'pages/Admin/categories';

const AdminPrivateRoutes = () => {
  const dispatch: any = useDispatch();
  const [surveyQuestionsChanged, setSurveyQuestionsChanged] = React.useState(false);
  const [clientsChanged, setClientsChanged] = React.useState(false);
  const { COMPANY, ADMINS, EMPLOYEES, CLASSIFICATION, SURVEYQUESTIONS, SURVEYCATEGORIES } = AdminPrivateRoutesDirectives;
  const navigate = useNavigate();
  const gotoNavigate = (link: To) => {
    navigate(link);
  };
  const handleIdle = () => {
    logout(dispatch);
    setTimeout(() => gotoNavigate(PublicRoutes.ADMINLOGIN), 0);
    toast.error('Session expired! Please login again.', alertOptions);
  };
  useIdleTimer({
    timeout: 3600000,
    // timeout: 10000,

    //  promptTimeout: 5000 / 2,
    //  onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 500,
  });


  return (
    <Routes>
      <Route path='/' element={<Navigate to={COMPANY} replace />} />
      <Route
        path={COMPANY}
        element={
          <PrivateLayout path={COMPANY} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Company setClientsChanged={setClientsChanged} clientsChanged={clientsChanged}/>
          </PrivateLayout>
        }
      />
      <Route
        path={`${EMPLOYEES}/:companyId`}
        element={
          <PrivateLayout path={EMPLOYEES} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Employees />
          </PrivateLayout>
        }
      />
      <Route
        path={`${CLASSIFICATION}/:companyId`}
        element={
          <PrivateLayout path={CLASSIFICATION} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Classififcation />
          </PrivateLayout>
        }
      />
      <Route path={SURVEYQUESTIONS}
         element={
          <PrivateLayout path={SURVEYQUESTIONS} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Questions  setSurveyQuestionsChanged={setSurveyQuestionsChanged} surveyQuestionsChanged={surveyQuestionsChanged}/>
          </PrivateLayout>
         }
      />
      <Route path={SURVEYCATEGORIES}
         element={
          <PrivateLayout path={SURVEYCATEGORIES} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Categories />
          </PrivateLayout>
         }
      />
      <Route
        path={ADMINS}
        element={
          <PrivateLayout path={ADMINS} setSurveyQuestionsChanged={setSurveyQuestionsChanged} setClientsChanged={setClientsChanged}>
            <Admins />
          </PrivateLayout>
        }
      />
      
      <Route path='*' element={<Navigate to='/' />} />
    </Routes>
  );
};

export default AdminPrivateRoutes;
